import { render, staticRenderFns } from "./EnableConversationSummaryAlert.vue?vue&type=template&id=b0fa7b6c&"
import script from "./EnableConversationSummaryAlert.vue?vue&type=script&lang=js&"
export * from "./EnableConversationSummaryAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports